<nz-layout class="app-layout">
  <!--
    `nzBreakpoint` 是**故意去掉的**：它会在初始化那一拍按窗口宽度强推一次收起状态，
    把 `collapsed` 里存着的上次选择冲掉（理由见 `main.component.ts` 上那条注释）。
    改成显式的一进一出，不再依赖双向绑定对 signal 的隐式写回。
  -->
  <nz-sider
    class="menu-sidebar"
    nzWidth="256px"
    [nzCollapsed]="collapsed()"
    (nzCollapsedChange)="collapsed.set($event)"
    [nzTrigger]="null"
  >
    <div class="sidebar-logo">
      <a routerLink="/main/debug">
        <!-- 图标是 `public/uart.svg` 那个图形，颜色跟着当前主题的主色走 —— 这里只放一个空壳，
             图形与颜色都由 `.logo-mark` 那条规则给（为什么不能是 `<img>` 写在那边）。
             `role` + `aria-label` 是顶替 `<img>` 那个 `alt`：换了写法，链接的可读名字不该跟着变。 -->
        <span class="logo-mark" role="img" aria-label="logo"></span>
        <h1>{{ currentTitle() }}</h1>
      </a>
    </div>
    <ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="collapsed()">
      <!--
        「调试」排在最前：选端口与配参数都在这一页的表头里（原来那个独立的「串口配置」页已删），
        它才是这个应用真正意义上的第一步，后面的测试/历史都建立在已经连上串口这个前提之上。
      -->
      <li nz-menu-item routerLink="/main/debug" [nzMatchRouter]="true">
        <nz-icon nzType="tool" nzTheme="outline" />
        <span>{{ '串口调试' | translate }}</span>
      </li>
<!--      <li nz-menu-item routerLink="/main/test" [nzMatchRouter]="true">-->
<!--        <nz-icon nzType="bug" nzTheme="outline" />-->
<!--        <span>{{ '测试' | translate }}</span>-->
<!--      </li>-->
<!--      <li nz-menu-item routerLink="/main/history" [nzMatchRouter]="true">-->
<!--        <nz-icon nzType="history" nzTheme="outline" />-->
<!--        <span>{{ '历史' | translate }}</span>-->
<!--      </li>-->

<!--      <li nz-submenu nzTitle="{{ '协议' | translate }}" nzIcon="api">-->
<!--        <ul>-->
          <li nz-menu-item routerLink="/main/protocol" [nzMatchRouter]="true">
            <nz-icon nzType="api" nzTheme="outline" />
            <span>{{ '自定义协议' | translate }}</span>
          </li>
          <li nz-menu-item routerLink="/main/modbus" [nzMatchRouter]="true">
            <!-- 这颗图标就是字母 M（下面 BACnet 那颗是字母 B），图标库里没有、也不是图片。
                 这里只放一个空壳，字母由 `.modbus-icon::after` 的 `content` 给 —— 图形与颜色都在样式里，
                 颜色走继承，所以跟旁边那些 <nz-icon> 一样**跟着主题与选中态变色**。
                 `anticon` 这个类是必须的，不是抄着好看的：菜单图标的 min-width / 字号 / 与文字的 10px
                 间距全挂在 antd 的 `.ant-menu-item .anticon`（和 `.anticon + span`）上，平时是 nz-icon
                 自己带上，自己画图形就得自己带。尺寸写在样式里是 1em —— 侧栏折叠时 antd 把字号从
                 14px 提到 16px，图标跟着一起长，和旁边那些 <nz-icon> 一样。
                 这里用 aria-hidden 而不是 nz-icon 默认的 `role="img" aria-label="<图标名>"`：
                 后者会让读屏把图标念成图标名（api / history 那类），紧接着再念一遍菜单名。 -->
            <span class="anticon modbus-icon" aria-hidden="true"></span>
            <span>{{ 'Modbus' | translate }}</span>
          </li>
          <li nz-menu-item routerLink="/main/bacnet" [nzMatchRouter]="true">
            <!-- 同上那颗自己画的图标，字母换成 B（样式见 `.bacnet-icon`）。
                 下面 DMX512 / DNP3 两项**也一样**：一颗**数字 5**、一颗字母 D —— 侧栏里几个协议
                 于是各占一个字符，不再共用 `nzType="apartment"` 那张图（各页都有了之后，共用一张
                 图反而认不出谁是谁）。PROFIBUS 那颗字母 P 的样式也一并留着，但它的路由与页面
                 还没有，这一项先收在注释里（见下）。 -->
            <span class="anticon bacnet-icon" aria-hidden="true"></span>
            <span>{{ 'BACnet' | translate }}</span>
          </li>
          <!-- PROFIBUS 这一项先收起来：路由与页面都还没有（四个协议里只剩它没落地），
               点进去是空的，摆在侧栏里反而让人以为已经有了。图标那颗字母 P 的样式
               （`.profibus-icon`）留在样式表里，页面做完把下面这几行放出来即可。
          <li nz-menu-item routerLink="/main/profibus" [nzMatchRouter]="true">
            <span class="anticon profibus-icon" aria-hidden="true"></span>
            <span>{{ 'PROFIBUS' | translate }}</span>
          </li>
          -->
          <li nz-menu-item routerLink="/main/dmx512" [nzMatchRouter]="true">
            <!-- 这一颗是**数字 5**，不是字母 —— 它与 DNP3 都以 D 开头，取首字母会撞成两颗一样的
                 D，所以取名字里的数字（样式见 `.dmx512-icon`） -->
            <span class="anticon dmx512-icon" aria-hidden="true"></span>
            <span>{{ 'DMX512' | translate }}</span>
          </li>
          <li nz-menu-item routerLink="/main/dnp3" [nzMatchRouter]="true">
            <!-- 字母 D（样式见 `.dnp3-icon`） -->
            <span class="anticon dnp3-icon" aria-hidden="true"></span>
            <span>{{ 'DNP3' | translate }}</span>
          </li>
          <li nz-menu-item routerLink="/main/plc" [nzMatchRouter]="true">
            <nz-icon nzType="thunderbolt" nzTheme="outline" />
            <span>{{ 'PLBUS' | translate }}</span>
          </li>
      <!--        </ul>-->
<!--      </li>-->

      <!-- 账号 / 组只给登录的人看：本应用匿名优先，没登录这两页整体都要被守卫挡到 /passport，
           摆出来只添乱。 -->
<!--      @if (account.login()) {-->
<!--        <li nz-menu-item routerLink="/main/account" [nzMatchRouter]="true">-->
<!--          <nz-icon nzType="user" nzTheme="outline" />-->
<!--          <span>{{ '账号' | translate }}</span>-->
<!--        </li>-->
<!--        <li nz-menu-item routerLink="/main/organization" [nzMatchRouter]="true">-->
<!--          <nz-icon nzType="team" nzTheme="outline" />-->
<!--          <span>{{ '组织' | translate }}</span>-->
<!--        </li>-->
<!--      }-->

<!--      <li nz-menu-item routerLink="/main/product" [nzMatchRouter]="true">-->
<!--        <nz-icon nzType="appstore" nzTheme="outline" />-->
<!--        <span>{{ '产品' | translate }}</span>-->
<!--      </li>-->
    </ul>

    <!-- 版本号钉在侧栏底部（`margin-top: auto` 推开，见 `.sidebar-version` 那条）。
         只有 `package.json` 里的版本，不带「版本」二字：加了就得往 66 个词典里再塞一条
         i18n 词条，而 `v0.2.3` 这种写法本来就跨语言通用。 -->
    <div class="sidebar-version">v{{ version }}</div>
  </nz-sider>
  <nz-layout class="app-inner-layout">
    <nz-header>
      <div class="app-header">
        <span class="header-trigger" (click)="collapsed.set(!collapsed())">
          <nz-icon class="trigger" [nzType]="collapsed() ? 'menu-unfold' : 'menu-fold'" />
        </span>

        <!--
          串口工具条。**放在布局层而不是调试页里**：串口连接是全局状态（`UartService` 是单例，
          切路由不丢），工具条却只挂在调试页的话，切到 Modbus 点表就看不见连接状态了。
          它零 `@Input()`、零 `@Output()`，本身就与宿主页面无关。
        -->
        <main-uart-bar />

        <span class="header-right">
          <ul nz-menu nzTheme="light" nzMode="horizontal">
            <li nz-menu-item [nzMatchRouter]="true" (click)="changeLanguage()">
              <nz-icon nzType="global" />
              <span>{{ '语言' | translate }}</span>
            </li>

            <!-- 主题：点开是八张卡（4 × 2，上常规下紧凑、同列同色），点一下立即生效并关窗 -->
            <li nz-menu-item [nzMatchRouter]="true" (click)="changeTheme()">
              <nz-icon nzType="sun"/>
              <span>{{ '主题' | translate }}</span>
            </li>

            @if (account.login()) {
              <!--
                登录后顶栏就一个菜单项 → 账号页：头像 + 名称。名称是「当前用户名称 或 当前组织名称」——
                选中有名组织显示组织名，否则（包括个人组织的空选中态）显示用户名。
                「退出」不在这里了：它只留在账号页页头的「退出」按钮里（`AccountComponent`）。
              -->
              <li nz-menu-item [nzMatchRouter]="true" (click)="changeOrganization()">
                <!--
                  账号 = 「组织快速切换」对话框（与语言/主题同一套弹窗写法）。组织列表见
                  OrganizationChangeComponent；「退出」等账号页内容经对话框里那个「账号」链接进入，
                  不再由顶栏直接导航。
                -->
                <nz-space>
                  <div *nzSpaceItem>
                    <nz-avatar nzIcon="user" [nzSrc]="account.user().avatar"></nz-avatar>
                  </div>
                  <div *nzSpaceItem>
                    <span>{{ account.organization().name || account.user().name }}</span>
                  </div>
                </nz-space>
              </li>
            } @else {
              <li nz-menu-item routerLink="/passport">
                <nz-icon nzType="login" nzTheme="outline" />
                <span>{{ '登录' | translate }}</span>
              </li>
            }
          </ul>
        </span>
      </div>
    </nz-header>
    <nz-content>
      <div class="inner-content">
        <router-outlet></router-outlet>
      </div>
<!--      <nz-footer>-->
<!--        2026-->
<!--        ({{ version }})-->
<!--      </nz-footer>-->
    </nz-content>
  </nz-layout>
</nz-layout>
